
import CourseTheatreFlow from "./CourseTheatreRecipe"

export const AllCourses =
    {
      "courses": 
      [
        CourseTheatreFlow,
        {
            "pathname": "",
            "name": "מכונית מרוץ",
            "description" : "בואו נכין מכונית מנייר שנוסעת ממש מהר, ומסלול מרוץ לתחרויות עם חברים! את המכונית אפשר לעצב ולקשט איך שרוצים!",
            "imgPath" : "assets/course/theatre/course-thumbnail_car.jpg",
            "isDisabled": true,
            "lessonsCount": 5
        },
        {
            "pathname": "",
            "name": "פינבול",
            "description" : "משחק פינבול מדליק עשוי כולו מקרטון, גומיות וכדור מגומי. בואו נהפוך כמה חתיכות קרטון פשוטות למכונת פינבול משוגעת ויצירתית!",
            "imgPath" : "assets/course/theatre/course-thumbnail_pinball.jpg",
            "isDisabled": true,
            "lessonsCount": 3
        },
        // {
        //     "pathname": "",
        //     "name": "ערכת יצירה אישית",
        //     "description" : "ערכת יצירה שכל יוצרת ויוצר חייבים שתהיה להם",
        //     "imgPath" : "assets/course/activityCards/thumb_racing-car_img.jpg",
        //     "activitypage" : "assets/course/activityCards/thumb_racing-car_activityPage.jpg",
        //     "isDisabled": true
        // },
        {
            "pathname": "",
            "name": "תיבת אוצר",
            "description" : "תיבת אוצר של פיראטים מקרטון עם עיטורים, מנעול ואפילו מדבקות של גולגולות. כשהתיבה מוכנה, אפשר למלא אותה באוצרות!",
            "imgPath" : "assets/course/theatre/course-thumbnail_chest.jpg",
            "isDisabled": true,
            "lessonsCount": 2
        },
        {
            "pathname": "",
            "name": "טירה",
            "description" : "בואו נכין טירה מקרטון שמתאימה ללגו ולפליימוביל. את הטירה אפשר לצבוע איך שרוצים – להוסיף דגלים, חלונות ודלתות!",
            "imgPath" : "assets/course/theatre/course-thumbnail_castle.jpg",
            "isDisabled": true,
            "lessonsCount": 4
        },
        {
            "pathname": "",
            "name": "חללית",
            "description" : "מוכנות ומוכנים לטוס לירח! חללית עם חלונות עגולים, כנפיים מגניבות ואפילו דלת נפתחת. עוד רגע יוצאים למסע אל החלל ולחקור עולמות חדשים!",
            "imgPath" : "assets/course/theatre/course-thumbnail_spaceship.jpg",
            "isDisabled": true,
            "lessonsCount": 4
        },
        {
            "pathname": "",
            "name": "עוד פעילויות בקרוב",
            "description": "אנחנו כל הזמן עובדים על פעילויות חדשות ומגניבות במיוחד! רוצים לדעת מתי הן עולות? עקבו אחרינו באינסטגרם ובפייסבוק, שם נפרסם את כל העדכונים וההפתעות.",
            "imgPath" : "assets/course/theatre/course-thumbnail_coming-soon.jpg",
            "isDisabled": true
        },
    ]
}

  export default AllCourses;

